import { dom } from '@fortawesome/fontawesome-svg-core'

Promise.all([
  import('./reviews.scss'),
  import('../../plugins/semantic/popup.js'),
  import('../../plugins/semantic/popup.css'),
]).then(() => {
  $('.widget.reviews').each(function (i, el) {
    $(el).data('widget', new Reviews(el))
    $(el).data('widget').init()
  })
})

function Reviews(el) {
  const self = this
  self.el = $(el)
  self.isLoaded = false
  self.reviewTemplate = require('./reviews.hbs')

  self.render = function (data) {
    const html = self.reviewTemplate({ data })
    self.el.find('.reviews-inner').html(html)

    if (self.el.find('.ui.tooltip').length) {
      self.el.find('.ui.tooltip').popup({
        on: 'click',
        inline: true,
        lastResort: true,
      })
    }
  }

  self.loadContent = function () {
    if (self.isLoaded) {
      return
    }

    $.ajax({
      url: self.el.attr('data-endpoint'),
      type: self.el.attr('data-method'),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        if (data.success) {
          self.render(data)
        } else {
          // If there is no tab content to show, remove the tab from the page
          const name = self.el.parents('.tab-content').attr('data-tab')
          window.dbs.globalEvents.emit('remove_tab', name, true)
        }

        self.isLoaded = true
        window.dbs.globalEvents.emit('tab_loaded', null, true)
      })
      .fail(function () {
        // TODO decide what happens on fail
      })
      .always(function () {
        // See: https://fontawesome.com/v5/docs/apis/javascript/methods#dom-i2svg-params
        dom.i2svg()
      })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('Reviews init', self)
    }
    self.el.css('opacity', 1)

    self.loadContent()

    window.dbs.globalEvents.subscribe('was_tab_loaded', function () {
      if (self.isLoaded) {
        window.dbs.globalEvents.emit('tab_loaded', null, true)
      }
    })
  }
}
